import { render, staticRenderFns } from "./DasmMarketPurchaserMenu.vue?vue&type=template&id=6a70834f&scoped=true&"
import script from "./DasmMarketPurchaserMenu.vue?vue&type=script&lang=js&"
export * from "./DasmMarketPurchaserMenu.vue?vue&type=script&lang=js&"
import style0 from "./DasmMarketPurchaserMenu.vue?vue&type=style&index=0&id=6a70834f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70834f",
  null
  
)

export default component.exports